import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PatternBoardAction } from '../../core/models/pattern-board-action.enum';
import { environment } from '../../../environments/environment';

/**
 * Asks an analytics admin what to do with a loaded Pattern Board: take a personal copy (the
 * behaviour every other user gets) or edit the shared board in place. Closes with the chosen
 * PatternBoardAction, or false when dismissed.
 */
@Component({
    selector: 'lynkd-pattern-dialog-board-pattern-action',
    templateUrl: './dialog-board-pattern-action.component.html',
    styleUrls: ['./dialog-board-pattern-action.component.scss']
})
export class DialogBoardPatternActionComponent {
    public useBrandivioBranding: boolean = environment.useBrandivioBranding;
    // eslint-disable-next-line @typescript-eslint/typedef
    public PatternBoardAction = PatternBoardAction;

    public constructor(public dialogRef: MatDialogRef<DialogBoardPatternActionComponent, PatternBoardAction | false>) {}

    public choose(action: PatternBoardAction): void {
        this.dialogRef.close(action);
    }
}
